<template>
  <div class="editorial">
    <div class="editorial_nav">

      <div class="editorial_txt">
        <div class="iconfont iconhomeicon evolution_tu" style="margin-right: 5px;"></div>
        <div class="editorial_txt2">
          首页 <span class="span1">></span> <span class="span2">学术指导</span>
        </div>
      </div>

      <div class="editorial_left">
        <div class="express_rtitle">
          <div class="waike">学术指导</div>
          <div class="waixian"></div>
        </div>

        <div class="express_nav2r">
          <!-- <div class="express_list2" v-for="(item,index) in list" :key="index">
            <div class="express_dian" :class="item.zt?'add2':''" @mouseover="addtop(1,item.id)" @mouseout="addtop(2,item.id)"></div>
            <div class="express_wen" @mouseover="addtop(1,item.id)" @mouseout="addtop(2,item.id)" style="overflow: hidden;width: 96%;">
              <div class="wen1" :class="item.zt?'add1':''" style="float: left;"><span class="span3" :class="item.zt?'add1':''">{{item.txt}}</span><span
                  style="max-width: 30%; float: right;text-align: right;">{{item.time}}</span></div>
            </div>
          </div> -->
          <div class="topContent">
            <p style="color:#222B3D;lineHeight:30px;">
              临床医学的发展离不开高质量的临床科研作为基础，而我国的传统医学教育缺乏针对这方面的系统教育。为了满足广大临床心血管专业医生开展科研活动的需求，针对当前临床心血管领域的医生在基金申请、科研立项、课题设计、医学统计、评价指标、论文撰写、期刊评估学等各个环节容易出现的问题，中国循环杂志组织了这方面的专家，针对每个医生的不同特点。重磅推出app在线一对一培训服务。现在报名并下载app即可获得5000个学米。将由资深专家为您提供学术指导服务。
            </p>
          </div>

           <div class="topContentInput">

             <div class="inputMain">
                  <span class="spanTitle">在线提交申请</span>
                  <el-input  v-model="nameInput" placeholder="请输入姓名"  class="nameInput"></el-input>
                  <el-input  v-model="passwordInput" placeholder="请输入密码" type="password" class="passwordInput"></el-input>
                  <el-button class="button">提交申请</el-button>
             </div>
             
          </div>
        </div>

        <!-- <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage3"
          layout="prev, pager, next, jumper"
          :total="total">
        </el-pagination> -->

      </div>
      <div class="editorial_right">
        <advertisement :num="num" :list2="list2"></advertisement>
      </div>
    </div>
  </div>
</template>

<script>
//配置右侧广告栏
import advertisement from "../public/evolution/advertisement.vue"

export default {
  components:{
    advertisement
  },
  data () {
    return {
      currentPage3: 1,//当前页数
      total: 0,//总条数
      nameInput:'',
      passwordInput:'',
      num:{
        wai: false,
        zixun: true,
        xia: true,
        look: false,
		video2: true,
      },//控制广告栏的显示隐藏
      list2: [
        {
          id: 1,
          txt: '多西他赛对进展期胃癌术后化疗疗效影响向...'
        },
        {
          id: 2,
          txt: '中国腹腔镜减重代谢外科20年研究文献分析...'
        }
      ],//外科天地
      list: [
        {
          id: 1,
          txt: '多西他赛对进展期胃癌术后化疗多西他赛对进展期胃癌术后化疗123',
          time: '2020-03-25'
        },
        {
          id: 2,
          txt: '中国腹腔镜减重代谢外科20年研究中国腹腔镜减重代谢外科20年研究',
          time: '2020-03-25'
        },
        {
          id: 3,
          txt: '多西他赛对进展期胃癌术后化疗多西他赛对进展期胃癌术后化疗',
          time: '2020-03-25'
        },
        {
          id: 4,
          txt: '多西他赛对进展期胃癌术后化疗多西他赛对进展期胃癌术后化疗',
          time: '2020-03-25'
        },
        {
          id: 5,
          txt: '多西他赛对进展期胃癌术后化疗多西他赛对进展期胃癌术后化疗',
          time: '2020-03-25'
        },
        {
          id: 6,
          txt: '多西他赛对进展期胃癌术后化疗多西他赛对进展期胃癌术后化疗',
          time: '2020-03-25'
        },
        {
          id: 7,
          txt: '多西他赛对进展期胃癌术后化疗多西他赛对进展期胃癌术后化疗',
          time: '2020-03-25'
        },
        {
          id: 8,
          txt: '多西他赛对进展期胃癌术后化疗多西他赛对进展期胃癌术后化疗',
          time: '2020-03-25'
        },
        {
          id: 9,
          txt: '多西他赛对进展期胃癌术后化疗多西他赛对进展期胃癌术后化疗',
          time: '2020-03-25'
        },
        {
          id: 10,
          txt: '多西他赛对进展期胃癌术后化疗多西他赛对进展期胃癌术后化疗123',
          time: '2020-03-25'
        },
        {
          id: 11,
          txt: '中国腹腔镜减重代谢外科20年研究中国腹腔镜减重代谢外科20年研究',
          time: '2020-03-25'
        },
        {
          id: 12,
          txt: '多西他赛对进展期胃癌术后化疗多西他赛对进展期胃癌术后化疗',
          time: '2020-03-25'
        },
        {
          id: 13,
          txt: '多西他赛对进展期胃癌术后化疗多西他赛对进展期胃癌术后化疗',
          time: '2020-03-25'
        },
        {
          id: 14,
          txt: '多西他赛对进展期胃癌术后化疗多西他赛对进展期胃癌术后化疗',
          time: '2020-03-25'
        },
        {
          id: 15,
          txt: '多西他赛对进展期胃癌术后化疗多西他赛对进展期胃癌术后化疗',
          time: '2020-03-25'
        },
        {
          id: 16,
          txt: '多西他赛对进展期胃癌术后化疗多西他赛对进展期胃癌术后化疗',
          time: '2020-03-25'
        },
        {
          id: 17,
          txt: '多西他赛对进展期胃癌术后化疗多西他赛对进展期胃癌术后化疗',
          time: '2020-03-25'
        }
      ],//浏览排行
    }
  },

  methods:{
      index(){
        this.total = this.list.length;
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
      },
      handleCurrentChange(val) {
        this.currentPage3 = val;
        console.log(`当前页: ${val}`);
      },
      //鼠标悬停
      addtop(num,id){
        if(num==1){
          for(var i=0;i<this.list.length;i++){
            if(id==this.list[i].id){
              this.list[i].zt = true;
              this.list.push('1');
              this.list.pop('1');
            }
          }
        }else{
          for(var i=0;i<this.list.length;i++){
            this.list[i].zt = false;
            this.list.push('1');
            this.list.pop('1');
          }
        }
      },
  },
  created(){
    this.index();
  }
}
</script>

<style lang="scss" scoped>
*{
    margin: 0;
    padding: 0;
}
.editorial{
  width: 100%;
  min-width: 1366px;
  background-color: #FFFFFF;
  .editorial_nav{
    width: 85%;
    margin: 0 auto;
    overflow: hidden;
    .editorial_txt{
      width: 100%;
      margin-top: 24px;
      margin-bottom: 26px;
      overflow: hidden;
      .evolution_tu{
        width: 19px;
        height: 17px;
        float: left;
      }
      .editorial_txt2{
        float: left;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #010101;
        .span1 {
          margin: 0 5px;
        }
        .span2 {
          color: var(--xt);
        }
      }
    }
    .editorial_left{
      width: 72%;
      margin-right: 3%;
      float: left;
      .express_rtitle {
        width: 100%;
        overflow: hidden;
        border-bottom: 3px solid #DBDBDB;
        padding-bottom: 11px;
        position: relative;
         .waike {
          width: 50%;
          float: left;
          font-size: 26px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #2A2D3E;
          line-height: 23px;
          margin-bottom: 20px;
        }
        .waixian {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100px;
          height: 3px;
          background: var(--biao);
        }
      }
      .express_nav2r {
        width: 100%;
        overflow: hidden;
        margin-top: 29px;
        .topContent{
           margin: 0 auto;
           width: 60%;
           height: 180px;
        }
        .topContentInput{
           margin: 0 auto;
           width: 75%;
           height: 300px;
           background-color: #F15A66;
           position: relative;
           .inputMain{
             height: 75%;
             margin: 0 auto;
             width: 80%;
             position: absolute;
             top: 13%;
             left: 10%;
             text-align: center;
             .nameInput{
               margin-top: 20px;
             }
             .passwordInput{
               margin-top: 20px;
             }
             .spanTitle{
               padding-top: 20px;
               color:#FFFFFF;
             }
             .button{
               width: 30%;
               height: 40px;
               margin-top: 30px;
               background-color: #F94C02;
               border: none;
               color: #FFFFFF;
               font-family: PingFangSC-Regular, PingFang SC;
             }
           }
        }

        .express_list2 {
          width: 100%;
          overflow: hidden;
          cursor: pointer;
          margin-bottom: 12.3px;
          border-bottom: 1px solid #EBEBEB;
          line-height: 62px;
          .express_dian {
            width: 10px;
            height: 10px;
            background: #DBDBDB;
            border-radius: 50%;
            margin-right: 15px;
            float: left;
            margin-top: 27px;
          }

          .express_wen {
            width: 91%;
            float: left;

            .wen1 {
              width: 100%;
              font-size: 16px;
              font-family: Adobe Heiti Std;
              font-weight: normal;
              color: #000000;


              .span3 {
                width: 80%;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
                float: left;
              }
            }

            .wen2 {
              width: 100%;
              font-size: 14px;
              font-family: Adobe Heiti Std;
              font-weight: normal;
              color: #636363;
              margin-bottom: 10px;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
            }
          }

          .zhai {
            width: 90%;
            padding-left: 31px;
            overflow: hidden;
            float: left;

            .wen3 {
              width: 50%;
              font-size: 14px;
              font-family: Adobe Heiti Std;
              font-weight: normal;
              color: #636363;
              float: left;
            }

            .zhai_left,
            .zhai_right {
              font-size: 14px;
              font-family: Adobe Heiti Std;
              font-weight: normal;
              color: #000000;
              float: right;
            }

            .zhai_right {
              margin-left: 30px;
            }

            .zhai_left:hover {
              text-decoration: underline;
              color: var(--biao);
            }

            .zhai_right:hover {
              text-decoration: underline;
              color: var(--biao);
            }
          }
        }
      }
      .el-pagination{
        text-align: center;
        margin-top: 30px;
      }
    }
    .editorial_right{
      width: 25%;
      float: left;
    }
  }
}
.add1 {
  color: var(--xt) !important;
  text-decoration: underline;
}

.add2 {
  background-color: var(--xt) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/nav/reprint.vue